import { usePostV1TemplatesChatWithExtraction } from '../api/generated/endpoint';
import {
    ChatMessageRequest,
    ChatWithExtractionRequest,
    ChatWithExtractionResponse,
} from '../api/generated/models';
import useGenericErrorToast from './useGenericErrorToast';

export const useChatBot = () => {
    const { mutate: chatWithExtractionRequest } =
        usePostV1TemplatesChatWithExtraction();
    const showGenericErrorToast = useGenericErrorToast();

    const chatWithAI = async (
        processId: number = 1,
        messages: ChatMessageRequest[]
    ): Promise<ChatWithExtractionResponse> => {
        return new Promise((resolve, reject) => {
            const messageToAI: ChatWithExtractionRequest = {
                processId: processId,
                messages: messages,
            };

            chatWithExtractionRequest(
                { data: messageToAI },
                {
                    onSuccess: async (response) => {
                        // console.log(response);
                        resolve(response as ChatWithExtractionResponse);
                    },
                    onError: (error) => {
                        showGenericErrorToast(error);
                        reject(error);
                    },
                }
            );
        });
    };

    return { chatWithAI };
};
